<template>
  <div style="position:relative">
    <div style="color:#888;margin:15px 0 5px 0;font-size:14px">
      一句话介绍：
    </div>
    <pre v-if="company.一句话简介" class="company-pre">{{ company.一句话简介 }}</pre>
    <div style="color:#888;margin:15px 0 5px 0;font-size:14px">
      高管整体介绍：
    </div>
    <pre v-if="company.领导介绍" class="company-pre">{{ company.领导介绍 }}</pre>
    <div style="color:#888;margin:15px 0 5px 0;font-size:14px">阿尔法认知：</div>
    <pre v-if="company.公司备注" class="company-pre">{{ company.公司备注 }}</pre>

    <div style="color:#888;margin:15px 0 5px 0;font-size:14px">职能模块认知：</div>
    <div class="categories">
      <el-tag v-for="item in companyCategories" :key="item._id" class="mr10 mb10 cate-item" size="small" :type="activeCategory._id === item._id && activeCategory.职能模块 === item.职能模块 ? '' : 'info'" @click="chooseCategory(item)">
        {{ item.职能模块 }}
      </el-tag>
    </div>
    <pre v-if="activeCategory.职能模块认知" class="company-pre">{{
      activeCategory.职能模块认知
    }}</pre>
    <p v-else>暂无职能模块认知，请尽快补充</p>

    <div style="padding-left:20px">
      <div class="edit-dialog-input-wrap">
        <el-input v-model="log" type="textarea" :rows="2"></el-input>
        <el-button size="mini" style="position:absolute;bottom:0;right:0" type="primary" class="custom-primary-plain" @click="saveLogFunc(log)">保存</el-button>
      </div>
      <div>
        <div
          v-for="item in showLogs"
          :key="item.createdAt"
          class="edit-dialog-single-p"
          style="flex-wrap:wrap"
        >
          <b style="font-weight:normal"
            >{{ dateFormat(item.createdAt) }} -- {{ item.account
            }}<span class="cate-tag">{{ activeCategory.职能模块 }}</span>
          </b>
          <div style="display:flex;width: 100%;align-items: flex-start;margin-top:10px;">
            <i class="el-icon-info mr10" style="flex:none"></i><span style="flex:auto;display: inline-block;white-space: pre-wrap;word-break: break-word;">{{ item.content }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    company: { type: Object, default: () => {} },
  },
  data() {
    return {
      companyCategories: [],
      companyCategoriesInEdit: [],
      activeCategory: {},
      activeCategoryInEdit: {},
      log: '',
    }
  },
  computed: {
    showLogs() {
      const logs = window._.cloneDeep(this.activeCategory.logs || [])
      logs.sort((a, b) => b.createdAt - a.createdAt)
      return logs
    },
    showEditingLogs() {
      const logs = window._.cloneDeep(this.activeCategoryInEdit.logs || [])
      logs.sort((a, b) => b.createdAt - a.createdAt)
      return logs
    },
  },
  methods: {
    async initData() {
      this.companyCategories = []
      this.companyCategoriesInEdit = []
      this.activeCategory = {}
      this.activeCategoryInEdit = {}
      this.log = ''
      this.loadData()
    },
    async saveLogFunc(log) {
      this.activeCategoryInEdit = window._.cloneDeep(this.activeCategory)
      if (!this.activeCategoryInEdit.logs) this.$set(this.activeCategoryInEdit, 'logs', [])
      this.activeCategoryInEdit.logs.push({
        createdAt: new Date().getTime(),
        account: app.user.account,
        content: log,
      })


      const res = await app.service('company').modifyComCateCognition({
        cid: this.company._id,
        option: {
          toupdate: [this.activeCategoryInEdit],
        },
      })
      if (res.status === 'success') {
        app.service('radish').addKpi({
          type: '职能模块认知',
          content: { cid: this.company._id },
        })
        this.loadData()
        this.log = ''
        localStorage[`companyCategory${this.activeCategory.职能模块}${this.company._id}`] = ''
      }
    },
    chooseCategory(item){
      this.activeCategory = item
      const remark = localStorage[`companyCategory${this.activeCategory.职能模块}${this.company._id}`]
      this.log = remark || ''
    },
    async loadData() {
      const res = await app.service('company').getComCateCognition(this.company._id)
      if (res.status === 'success') {
        res.data.forEach((element) => {
          if (element.logs && element.logs.length > 0) {
            element.logs.sort((a, b) => b.createdAt - a.createdAt)
          }
        })
        this.companyCategories = res.data
        this.chooseCategory(this.companyCategories[0])
      } else {
        this.$message.error(res.msg)
      }
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },
    async saveLog() {
      if (!this.log) return this.$message.error('请填写要保存的内容')
      if (!this.activeCategoryInEdit.logs) this.$set(this.activeCategoryInEdit, 'logs', [])
      this.activeCategoryInEdit.logs.push({
        createdAt: new Date().getTime(),
        account: app.user.account,
        content: this.log,
      })
      this.log = ''

      if (this.saving) return this.$message.warning('保存中，请稍后')

      this.saveing = true
      const companyCategories2String = this.companyCategories.map((v) => JSON.stringify(v))

      const toinsert = this.companyCategoriesInEdit.filter((v) => !v._id)
      const todelete = this.companyCategories.filter((v) => !this.companyCategoriesInEdit.find((a) => a._id === v._id))
      const toupdate = this.companyCategoriesInEdit.filter((v) => {
        if (!v._id) return false
        const str = JSON.stringify(v)
        return !companyCategories2String.find((a) => a === str)
      })

      toinsert.reverse()
      const option = { toinsert, todelete, toupdate }

      const res = await app.service('company').modifyComCateCognition({
        cid: this.company._id,
        option: option,
      })
      if (res.status === 'success') {
        app.service('radish').addKpi({
          type: '职能模块认知',
          content: { cid: this.company._id },
        })
        this.loadData()
        this.$message.success(`修改成功`)
      } else this.$message.error(`修改失败:${res.msg}`)
      this.saveing = false
    },
  },
}
</script>
<style src="../../../../company/statistics/css/fullCompanyDetail.css" scoped></style>
<style src="../../../../company/statistics/css/commonCompany.css" scoped></style>
<style scoped>
.categories {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
}
.cate-item {
  cursor: pointer;
}
.cate-delete-btn {
  margin-left: 5px;
  user-select: none;
}
.cate-tag {
  background-color: #eee;
  color: #afafaf;
  padding: 2px 10px;
  border-radius: 12px;
  margin-left: 6px;
  font-weight: normal;
}
.empty-alert {
  color: #cacaca;
  font-size: 16px;
}
.edit-dialog-input-wrap-border {
  border: 1px solid #eaeaea;
  width: 100%;
  padding: 10px;
  border-radius: 4px;
}
.company-pre {
  background-color: #fff;
}
</style>
